export default __webpack_public_path__ + "static/media/er3.9984d965.png";